import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ITaskSummaryData} from '../../misc/interfaces/ITaskSummaryData';
import {ICaseSummaryData} from '../../misc/interfaces/ICaseSummaryData';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {DataService} from '../../services/data.service';
import {ApplicationService} from '../../services/application.service';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgModalService, ExgOverlayService} from 'exc-controls-v2';
import {ExcRestService} from 'exc-rest-v2';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ReportDocArrangerComponent} from '../report-doc-arranger/report-doc-arranger.component';
import {ReportDocResultComponent} from '../report-doc-result/report-doc-result.component';

@Component({
  selector: 'app-report-doc-builder',
  templateUrl: './report-doc-builder.component.html',
  styles: []
})
export class ReportDocBuilderComponent extends ExcTranslation implements OnInit {
  @ViewChild('docArranger', { read: ReportDocArrangerComponent })
  docArranger!: ReportDocArrangerComponent;
  @ViewChild('docResult', { read: ReportDocResultComponent })
  docResult!: ReportDocResultComponent;
  @Input() oeID = '';
  Data: any;
  isLoading = true;
  isInit = true;
  tabinstance: any;
  selectedCount = 0;

  selectKey = '';
  selectedSummary: ITaskSummaryData | ICaseSummaryData | undefined;
  vorgOrAuNr = '';
  aueSchadenNr = '';
  auID = '';
  taskList: any[] = [];

  Events = new ExgApplicationEventEmitter();
  /*Workflow Timeline Navigation*/
  workflow: any[] = [
    {
      navigationName: this.getRessource('WFNav0')
      , headerText: this.getRessource('WFHeader0')
      , progress: 0
      , data: {}
      , requiredData: []
    },
    {
      navigationName: this.getRessource('WFNav1')
      , headerText: this.getRessource('WFHeader1')
      , progress: 0
      , data: {}
      , requiredData: []
    },
    {
      navigationName: this.getRessource('WFNav2')
      , headerText: this.getRessource('WFHeader2')
      , progress: 0
      , data: {}
      , requiredData: []
    }
  ];
  wfConfig = {
    isSavedVersion: false,
    isLoading: false,
    selectedWorkflowIndex: 0,
    wfDataAsArray: [] as any[]
  };

  /*DocArrangement*/
  objToAddInArranger: any = {};
  objToDeleteInArranger: any = {};
  /*ResultView*/
  sharedArrangedDocs: any[] = [];

  constructor(
    private dataSvc: DataService,
    public appSvc: ApplicationService,
    public enmSrv: EnumerationService,
    public excSecurity: ExcSecurityService,
    public overlayService: ExgOverlayService,
    private modal: ExgModalService,
    public excRest: ExcRestService) {
    super();
  }


  ngOnInit(): void {
    if (!this.excSecurity.isFeatured('REPORTBUILDER')) {
      this.tabinstance.Close();
    }
    if (this.tabinstance) {
      this.tabinstance.Label = 'Berichtsbuilder';
    } else {
      this.tabinstance.Label = '';
    }

    if (this.Data?.auID) {
      this.selectedSummary = this.dataSvc.Case.Summary.Get(this.Data.auID, undefined, {Events: this.Events});
    }
    else if (this.Data?.vorgID) {
      this.selectedSummary = this.dataSvc.Task.Summary.Get(this.Data.vorgID, undefined, {Events: this.Events});
    }
    else {
      this.modal.showToast('Berichtsbuilder konnte keine Daten laden', 'md-toast', 'fas fa-exclamation');
      this.tabinstance.Close();
    }
    this.registerEvents();
  }

  private registerEvents(): void {
    this.Events.Case?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      this.handleSummaryLoad(evt);
    });
    this.Events.Task?.Summary?.DataLoaded?.subscribe((evt: ExgEventArgs) => {
      this.handleSummaryLoad(evt);
    });
  }

  private handleSummaryLoad(evt: ExgEventArgs): void {
    if (evt.success) {
      if (this.Data?.auID && this.isInit) {
        this.selectKey = 'auID';
        this.vorgOrAuNr = this.selectedSummary?.caseDetails.data.auNr;
        this.aueSchadenNr = this.selectedSummary?.caseDetails.data.aueSchadenNr;
        this.auID = this.selectedSummary?.caseDetails.data.auID;
        this.oeID = this.selectedSummary?.caseDetails.data.au_oeID_Auftraggeber;
        this.taskList = this.selectedSummary?.taskList.data ?? [];
        this.tabinstance.Label = this.vorgOrAuNr + ' ' + this.tabinstance.Label;
        this.isLoading = false;
        this.isInit = false;
      } else if (this.Data?.vorgID && this.isInit) {
        this.selectKey = 'vorgID';
        this.vorgOrAuNr = this.selectedSummary?.taskDetails.data.vorgNr;
        this.aueSchadenNr = this.selectedSummary?.caseDetails.data.aueSchadenNr;
        this.auID = this.selectedSummary?.taskDetails.data.vorg_auID;
        this.oeID = this.selectedSummary?.caseDetails.data.au_oeID_Auftraggeber;
        this.taskList = this.selectedSummary?.taskList.data ?? [];
        this.tabinstance.Label = this.vorgOrAuNr + ' ' + this.tabinstance.Label;
        this.isLoading = false;
        this.isInit = false;
      }
    } else {
      this.modal.showToast('Berichtsbuilder konnte keine Daten laden', 'md-toast', 'fas fa-exclamation');
      this.tabinstance.close();
    }
  }

  /*Workflow Timeline Navigation*/

  navigateLeft(): void {
    if (this.wfConfig.selectedWorkflowIndex > 0) {
      this.wfConfig.selectedWorkflowIndex--;
      this.validateAndResetProgress();
    }
  }

  navigateRight(): void {
    if (this.wfConfig.selectedWorkflowIndex < this.workflow.length - 1) {
      if (this.canNavigateToNextStep()) {
        this.workflow[this.wfConfig.selectedWorkflowIndex].progress = 100;
        this.wfConfig.selectedWorkflowIndex++;
      }
    }
  }

  canNavigateToNextStep(): boolean {
    const currentIndex = this.wfConfig.selectedWorkflowIndex;
    return currentIndex === 0 ? this.selectedCount > 0
      : currentIndex === 1 ? this.sharedArrangedDocs?.length > 0 : true;
  }

  validateAndResetProgress(): void {
    if (this.selectedCount === 0) {
      this.workflow[0].progress = 0;
    }
    if (!this.sharedArrangedDocs?.length) {
      this.workflow[1].progress = 0; // reset arran
      this.workflow[2].progress = 0; // reset erg
    }
  }

  /*Selector --> Arranger*/
  addChosenObject($event: any): void {
    this.objToAddInArranger = {...$event};
    this.selectedCount++;
    this.workflow[0].progress = 100;
  }

  deleteChosenObject($event: any): void {
    this.objToDeleteInArranger = {...$event};
    if (this.selectedCount > 0) {
      this.selectedCount--;
    }
    this.validateAndResetProgress();
  }

  onArrangerChanged(newArray: any[]): void {
    this.sharedArrangedDocs = newArray;
    this.validateAndResetProgress();
  }
}
